import React from 'react';
const legend = [
  { text: 'Disabled', color: 'bg-neutral2' }, // EEECF1
  { text: 'Available', color: 'bg-neutral4' }, // BFBBC3
  { text: 'Booked', color: 'bg-neutral7' }, // 625E68
  { text: 'Selected', color: 'bg-primary1' } // FFD401
];

export default function BookingTimeTableLegend() {
  return (
    <div className="flex flex-wrap gap-4 justify-start sm:justify-center md:gap-6">
      {legend &&
        legend.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className={`h-8 w-8 rounded ${item?.color}`}></div>
            <div className="text-[16px] font-normal text-neutral7">{item.text}</div>
          </div>
        ))}
    </div>
  );
}
